import { UserAvatar } from '@features/user-avatar';
import * as stylex from '@stylexjs/stylex';
import { FC } from 'react';
import { Checkbox } from '@shared/ui/kit';
import { styles } from '../../styles';
import { Ticket } from '@pages/event/api/useFetchTicketSegment';

interface ParticipantInfoProps {
  name: string;
  position?: string;
  ticket: Ticket;
  checked?: boolean;
  disabled?: boolean;
  onToggle: () => void;
  hasGuests: boolean;
  isGuestsExpanded: boolean;
  onToggleGuests: () => void;
}

const getInitials = (name: string): string => {
  const names = name.trim().split(' ');
  const initials = names.map((name: string) => name.charAt(0).toUpperCase());
  return initials.join('').slice(0, 2);
};

export const ParticipantInfo: FC<ParticipantInfoProps> = ({
  name,
  position,
  checked,
  disabled,
  onToggle,
  ticket,
  hasGuests,
  isGuestsExpanded,
  onToggleGuests,
}) => {
  const isInactive = disabled;

  return (
    <div {...stylex.props(styles.participantInfoBlock)}>
      <div {...stylex.props(styles.checkbox)}>
        {isInactive ? (
          <input type="checkbox" disabled {...stylex.props(styles.checkboxDis)} />
        ) : (
          <Checkbox isChecked={!!checked} onChange={onToggle} />
        )}
      </div>

      <UserAvatar initials={getInitials(name)} />
      <div {...stylex.props(styles.personCard)}>
        <div {...stylex.props(styles.personDescription)}>
          <div {...stylex.props(styles.firstName)}>{name}</div>
          {isInactive ? (
            <div {...stylex.props(styles.inactivePosition)}>
              <span {...stylex.props(styles.inactivePositionText)}>Больше не работает</span>
            </div>
          ) : (
            <div {...stylex.props(styles.position)}>{position}</div>
          )}
          {hasGuests && (
            <div {...stylex.props(styles.guestsInfoRow)}>
              <div {...stylex.props(styles.guestsChips)}>
                {Boolean(ticket.dependents?.countExtraAdult) && (
                  <div {...stylex.props(styles.guestChip)}>Взрослых: {ticket.dependents?.countExtraAdult}</div>
                )}
                {Boolean(ticket.dependents?.countExtraChildren) && (
                  <div {...stylex.props(styles.guestChip)}>Детей: {ticket.dependents?.countExtraChildren}</div>
                )}
              </div>
              <button {...stylex.props(styles.detailsButton)} onClick={onToggleGuests}>
                {isGuestsExpanded ? 'Скрыть' : 'Подробнее'}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
